module.exports = __webpack_public_path__ + "img/cns_printer_mac34.40c30517.png";